
export default {
  name: 'ScrollTop',
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
      })
    },
  },
}
